export enum ActionsEnum {
	UPDATE_LAUDO = "UPDATE_LAUDO",
	UPDATE_LIST_LAUDO = "UPDATE_LIST_LAUDO",
	UPDATE_MESSAGE = "UPDATE_MESSAGE",
	UPDATE_SOLICITA_LAUDO_RESUMIDO = "UPDATE_SOLICITA_LAUDO_RESUMIDO",
	UPDATE_LAUDO_COMPLETO = "UPDATE_LAUDO_COMPLETO",
	UPDATE_LAUDO_COMPLETO_EDICAO = "UPDATE_LAUDO_COMPLETO_EDICAO",
	UPDATE_USUARIO_LOGADO = "UPDATE_USUARIO_LOGADO",
	UPDATE_LAUDO_PARAMS = "UPDATE_LAUDO_PARAMS",
	UPDATE_FILTRO_LAUDO = "UPDATE_FILTRO_LAUDO",
	UPDATE_IDENTIFICACAO_OBRA_PREENCHIDA = "UPDATE_IDENTIFICACAO_OBRA_PREENCHIDA",
	UPDATE_METODOS_PROCEDIMENTOS_PREENCHIDOS = "UPDATE_METODOS_PROCEDIMENTOS_PREENCHIDOS",
	UPDATE_ATIVIDADES_EXPLORADAS = "UPDATE_ATIVIDADES_EXPLORADAS"
}
